import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai';
import { updateUser } from '../../Api-Endpoints/apiEndpoint';
import toast from 'react-hot-toast';

const ViewUserModal = ({
  getUserByAdmin,
  showModal,
  setShowModal,
  selectUser,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [userDetails, setUserDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phone: '',
    roles: '',
  });

  // Populate the modal with selected user details when `selectUser` changes
  useEffect(() => {
    if (selectUser) {
      setUserDetails({
        firstName: selectUser.firstName || '',
        lastName: selectUser.lastName || '',
        email: selectUser.email || '',
        password: selectUser.password || '',
        phone: selectUser.phone || '',
        roles: selectUser._roles?.map(role => role.role?.name).join(', ') || '',
      });
    }
  }, [selectUser]);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const closeModal = () => setShowModal(false);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setUserDetails(prevDetails => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // Validate if all required fields are filled
  const validateForm = () => {
    const { firstName, password, email, lastName, phone } = userDetails;
    if (!firstName) {
      toast.error('First Name is required');
      return false;
    } else if (!password) {
      toast.error('Password is required');
      return false;
    }
    if (!lastName) {
      toast.error('Last Name is required');
      return false;
    } else if (!email) {
      toast.error('Email is required');
      return false;
    } else if (!phone) {
      toast.error('Phone number is required');
      return false;
    } else {
      return true;
    }
  };

  const handleEditUser = async id => {
    // Ensure we are using the latest userDetails from state
    const updatedDetails = { ...userDetails };

    // Validate the form inputs before proceeding
    if (!validateForm()) return; // Stop if validation fails

    try {
      const res = await updateUser(id, updatedDetails); // Pass the latest state
      if (res.success) {
        toast.success('User updated successfully!');
        getUserByAdmin(); // Refresh the user list
        closeModal();
      }
    } catch (error) {
      toast.error('Failed to update user.');
    }
  };
  return (
    <div>
      {showModal && (
        <Modal
          isOpen={showModal}
          onRequestClose={closeModal}
          contentLabel="User Details Modal"
          style={{
            content: {
              width: '65%',
              height: '50%',
              margin: 'auto',
              borderRadius: '20px',
              padding: 0,
            },
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
          }}
        >
          <div className="flex justify-between mx-5 my-3">
            <h1 className="text-2xl font-semibold">User Details</h1>
            <button onClick={closeModal}>
              <IoMdCloseCircleOutline size={20} />
            </button>
          </div>
          <hr />

          <div className="flex justify-between items-center mx-5 my-5 gap-5">
            <div>
              <div>
                <p>First Name</p>
                <input
                  className="p-2 w-full bg-purple-100 border rounded-lg text-sm outline-none my-1"
                  type="text"
                  name="firstName"
                  value={userDetails.firstName}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <p>Last Name</p>
                <input
                  className="p-2 w-full bg-purple-100 border rounded-lg text-sm outline-none my-1"
                  type="text"
                  name="lastName"
                  value={userDetails.lastName}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex justify-between gap-5 my-3">
                <div>
                  <p>Email</p>
                  <input
                    className="p-2 w-44 border bg-gray-100 rounded-lg text-sm outline-none my-1"
                    type="text"
                    disabled
                    name="email"
                    value={userDetails.email}
                    onChange={handleInputChange}
                  />
                </div>
                <div>
                  <p>Password</p>
                  <div className="flex items-center border bg-purple-100 rounded-lg text-sm outline-none my-1 pr-3">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="p-2 w-40 bg-transparent outline-none"
                      name="password"
                      value={userDetails.password}
                      onChange={handleInputChange}
                    />
                    {showPassword ? (
                      <AiFillEye
                        size={20}
                        color="red"
                        style={{ cursor: 'pointer' }}
                        onClick={togglePasswordVisibility}
                      />
                    ) : (
                      <AiFillEyeInvisible
                        size={20}
                        color="red"
                        style={{ cursor: 'pointer' }}
                        onClick={togglePasswordVisibility}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div>
                <p>Phone Number</p>
                <input
                  className="p-2 w-full bg-purple-100 border rounded-lg text-sm outline-none my-1"
                  type="text"
                  name="phone"
                  value={userDetails.phone}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <p>User Roles</p>
                <input
                  className="p-2 w-full bg-gray-100 border rounded-lg text-sm outline-none my-1"
                  type="text"
                  name="roles"
                  value={userDetails.roles}
                  readOnly
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end mx-5 my-3 gap-3">
            <button
              onClick={closeModal}
              className="border border-red-500 bg-red-500 text-white p-1 px-5 rounded-lg"
            >
              Close
            </button>
            <button
              onClick={() => handleEditUser(selectUser?._id)}
              className="border border-red-500 bg-red-500 text-white p-1 px-5 rounded-lg"
            >
              Save Changes
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ViewUserModal;
